import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {MaterialDescriptionsPage} from "./-page/material-descriptions.page";
import {MaterialDescriptionsPending} from "./-page/material-descriptions.pending";

export const Route = createFileRoute("/_app/engineering/materials/$materialId/descriptions/")({
  component: RouteComponent,
  pendingComponent: MaterialDescriptionsPending,
  staticData: {meta: {labelDescriptor: routeMessages.descriptions}},
});

function RouteComponent() {
  const {materialId} = useParams({strict: false}) as {materialId: string};
  const {includeDeleted} = Route.useSearch();

  return <MaterialDescriptionsPage materialId={materialId} includeDeleted={includeDeleted} />;
}
